import { IExecutionOptions } from '@kurtosys/types/query/index.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';

import { commonUtils } from '../../common/index.js';

import { BaseTransform } from './BaseTransform.js';

export class ParseTransform extends BaseTransform {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		let response: any = queryResponse;
		try {
			const { parseTransformOptions } = this.options;
			if (parseTransformOptions) {
				const { type = 'string' } = parseTransformOptions;
				if (!commonUtils.isNullOrUndefined(queryResponse) && type) {
					switch (type) {
						case 'float':
							response = parseFloat(response);
							break;
						case 'integer':
							response = parseInt(response, 10);
							break;
						case 'string':
							response = response.toString();
							break;
						default:
							break;
					}
				}
			}
		} catch (ex) {
			console.warn(`Error in ParseTransform: `, { queryResponse, options: this.options }, ex);
		}
		return response;
	}
}
